module.exports = __webpack_public_path__ + "img/Newbie_Dagger_03_Ranger.a50d0d72.png";